import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';
export const HOST_AGENT = new InjectionToken<string>('HOST_AGENT');
export const HOST_DEVICE = new InjectionToken<string>('HOST_DEVICE');
export const REQUEST: InjectionToken<Request> = new InjectionToken<Request>('REQUEST');
export const RESPONSE: InjectionToken<Response> = new InjectionToken<Response>('RESPONSE');
